module.exports = __webpack_public_path__ + "static/media/EvilIcons.140c53a7.ttf";